import _ from "lodash";

const defaultState = () => ({ userPartner: null });

export default (state = defaultState(), { type, payload }) => {
    switch (type) {
        case "PARTNERS:GET-PARTNER-SUCCESS": {
            const { userPartner } = payload;
            return { ...state, userPartner };
        }
        case "PARTNERS:GET-PARTNER-ERROR": {
            return { ...state, userPartner: null };
        }
        case "PARTNERS:ASSOCIATE-PARTNER-SUCCESS": {
            const { userPartner } = payload;
            return { ...state, userPartner, associatedSuccessfully: true};
        }
        case "PARTNERS:ASSOCIATE-PARTNER-ERROR": {
            return { ...state, associatedSuccessfully: false, error: _.get(payload, 'e.message', 'Oops! something went wrong') };
        }
        case "PARTNERS:SHOW-GALLERY": {
            return { ...state, associatedSuccessfully: false};
        }
        default:
            return state;
    }
};